<template>
  <div class="select-wrap" v-if="selectShow">
    <div class="select-con">
      <div class="select-header">
        <img src="@/assets/images/topBorder.png" alt="">
      </div>
      <div class="select-body">
        <h6>机构选择</h6>
        <el-input
          class="select-input"
          placeholder="-关键词搜索-"
          suffix-icon="el-icon-search"
          v-model="keyword"
          @input="handleKeywordInput">
        </el-input>
        <div class="select-xlk">
          <p>筛选条件：</p>
          <div>
            <el-select class="xlk" v-model="province" placeholder="-请选择省份-" @change="handleProvinceSelect">
              <el-option
                v-for="item in provinceData"
                :key="item.orgId"
                :label="item.province"
                :value="item.province">
              </el-option>
            </el-select>
            <el-select class="xlk" v-model="city" placeholder="-请选择城市-" @change="handleCitySelect">
              <el-option
                v-for="item in cityData"
                :key="item.orgId"
                :label="item.city"
                :value="item.city">
              </el-option>
            </el-select>
            <el-select class="xlk" v-model="organization" placeholder="-请选择机构-" @change="handleOrganizationSelect">
              <el-option
                v-for="item in organizationData"
                :key="item.orgId"
                :label="item.orgName"
                :value="item.orgName">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="result">
          <p v-for="item in resultData" :key="item.orgId" @click="handleSkip(item)">{{item.orgName}}</p>
        </div>
      </div>
      <div class="select-footer">
        <img src="@/assets/images/bottomBorder.png" alt="">
        <p v-if="organization" @click="handleSkip(selectOrganization)">进入</p>
      </div>
      <div class="close" @click="handleClose">
        <img src="@/assets/images/turn_off.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
export default {
  props: ['selectShow'],
  data () {
    return {
      resultData: [],
      keyword: '',
      original: [],
      province: '',
      provinceData: [],
      city: '',
      cityData: [],
      organization: '',
      organizationData: [],
      selectOrganization: {}
    }
  },
  created () {
    http.getOrglist().then(res => {
      let data = res.data.data
      this.resultData = data
      this.original = data
      this.provinceData = this.unique(data, 'province')
    })
  },
  methods: {
    handleClose () {
      this.$emit('handleClose', false)
    },
    handleSkips () {
      console.log(this.organizationData)
    },
    handleSkip (data) {
      window.open('https://tests.xinlicloud.com/#/index?abbr=' + data.url)
    },
    handleKeywordInput () {
      this.resultData = this.original.filter((item, index) => {
        return item.orgName.indexOf(this.keyword) > -1
      })
    },
    handleProvinceSelect () {
      this.city = ''
      this.cityData = []
      this.organization = ''
      this.organizationData = []
      let data = this.original.filter((item, index) => {
        return item.province.indexOf(this.province) > -1
      })
      this.cityData = this.unique(data, 'city')
    },
    handleCitySelect () {
      this.organization = ''
      this.organizationData = []
      let data = this.original.filter((item, index) => {
        return item.city.indexOf(this.city) > -1
      })
      this.organizationData = this.unique(data, 'orgName')
    },
    handleOrganizationSelect () {
      let url = this.organizationData.filter((item, index) => {
        return item.orgName.indexOf(this.organization) > -1
      })
      this.selectOrganization = url[0]
    },
    unique (arr, type) {
      var obj = {}
      return arr.filter((item, index, arr) => {
        return obj.hasOwnProperty(typeof item[type] + item[type]) ? false : (obj[typeof item[type] + item[type]] = true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 @import '../assets/css/sass/variable.sass';
.select-wrap {
  width:100%;
  height: 100vh;
  position: fixed;
  top:0;
  left:0;
  background: rgba(0,0,0,.45);
  z-index: 1000;
  overflow-y: scroll;
  .select-con {
    width: 533px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 15px;
    .select-header {
      position: absolute;
      top:-90px;
      img {
        width: 533px;
        height: 240px;
      }
    }
    .select-body {
      width: 470px;
      margin: 148px auto 60px;
      h6 {
        color: $el-main-color;
        padding-bottom:5px;
        border-bottom: 1px dashed #333;
      }
      .select-input {
        width: 60%;
        margin: 20px 0;
      }
      .select-xlk{
        p{
          margin-bottom: 10px;
        }
        div{
          display: flex;
          justify-content: space-between;
          .xlk {
            width: 30%;
          }
        }
      }
      .result {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        p{
          padding:3px 10px;
          border:1px solid #FF8B00;
          color: #FF8B00;
          font-size: 12px;
          border-radius: 3px;
          margin-right: 15px;
          margin: 5px 15px 5px 0;
          cursor: pointer;
          &:hover {
            color:#fff;
            background: #FF8B00;
          }
        }
      }
    }
    .select-footer {
      position: absolute;
      bottom:-4px;
      img {
        width: 533px;
        height: 43px;
      }
      p {
        position: absolute;
        bottom:30%;
        left:46%;
        color: #fff;
        cursor: pointer;
        transform: scale(1);
        animation: changeBiger 1s infinite ease-in-out alternate;
      }
    }
    .close {
      position: absolute;
      bottom:-98px;
      left: 50%;
      margin-left: -23px;
      cursor: pointer;
      img {
        width: 46px;
        height:94px;
      }
    }
  }
}
@keyframes changeBiger {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/select.vue